import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

/*
    Wraps the Router component from react-router-dom and renders the children passed in from the props.
    This is done so that the children have access to other apis exposed by react-router-dom (like 
    navigate and useLocation)
*/
function AppRouter(props) {
  return <Router>{props.children}</Router>;
}

export default AppRouter;
